import { op as openpanel } from './config/openpanelConfig';
import { resetGleap } from './initGleap';

export const resetTracking = () => {
  if (openpanel) {
    try {
      openpanel.clear();
    } catch (error) {
      console.error('Error clearing OpenPanel state', error);
    }
  }

  resetGleap();
};
